import {
  Package,
  UserCheck,
  Truck,
  Warehouse,
  Wrench,
  ClipboardCheck,
  Trash2,
  Recycle,
  ShieldCheck,
  ArchiveRestore,
  Plus,
  ScanLine,
  Send,
} from "lucide-react";

const ICONS = {
  asset_created: Package,
  reserved_for_request: ClipboardCheck,
  assigned: UserCheck,
  assigned_on_delivery: UserCheck,
  packed: Package,
  shipment_dispatched: Truck,
  shipment_in_transit: Truck,
  shipment_out_for_delivery: Truck,
  shipment_delivered: Send,
  shipment_closed: Send,
  pickup_scheduled: ScanLine,
  pickup_picked_up: Truck,
  pickup_in_transit: Truck,
  pickup_received: Warehouse,
  pickup_inspected: ClipboardCheck,
  pickup_closed: ArchiveRestore,
  inspection_complete: ClipboardCheck,
  erasure_started: ShieldCheck,
  erasure_certified: ShieldCheck,
  service_created: Wrench,
  service_closed: Wrench,
  itad_initiated: Recycle,
  itad_completed: Trash2,
  recovery_scheduled: Truck,
};

function formatTs(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default function Timeline({ items }) {
  if (!items?.length) {
    return (
      <div className="text-sm text-slate-500 py-8 text-center border border-dashed border-slate-200 rounded-md">
        No lifecycle events recorded yet.
      </div>
    );
  }
  return (
    <ol className="relative border-l border-slate-200 ml-3 space-y-6 py-2">
      {items.map((e, idx) => {
        const Icon = ICONS[e.event_type] || Plus;
        return (
          <li key={e.id || idx} className="ml-6 relative">
            <span className="absolute -left-[34px] top-0.5 flex h-7 w-7 items-center justify-center rounded-full bg-white border border-slate-300 timeline-dot">
              <Icon className="h-3.5 w-3.5 text-slate-700" strokeWidth={1.6} />
            </span>
            <div className="flex flex-col gap-0.5">
              <div className="text-sm font-medium text-slate-900 capitalize">
                {String(e.event_type || "").replace(/_/g, " ")}
              </div>
              <div className="text-xs text-slate-500">
                {formatTs(e.timestamp)}
                {e.actor_email ? ` · ${e.actor_email}` : ""}
                {e.ref_id ? ` · ref ${String(e.ref_id).slice(0, 8)}` : ""}
              </div>
              {e.new_value ? (
                <div className="text-xs text-slate-600 font-mono bg-slate-50 border border-slate-100 rounded px-2 py-1 mt-1 max-w-full overflow-x-auto">
                  {typeof e.new_value === "string" ? e.new_value : JSON.stringify(e.new_value)}
                </div>
              ) : null}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
